import { format } from "date-fns";

export function timestampToDateString(timestamp: number) {
  // https://date-fns.org/v2.28.0/docs/format
  return format(new Date(timestamp), "LLL-dd-yyyy kk:mm");
}
